import { useEffect, useRef } from 'react';
export function useOnPointerDownOutside(handler) {
    const ref = useRef(null);
    useEffect(() => {
        const listener = (event) => {
            var _a;
            if (!((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                handler(event);
            }
        };
        document.addEventListener('pointerdown', listener);
        return () => {
            document.removeEventListener('pointerdown', listener);
        };
    }, [handler, ref]);
    return ref;
}
//# sourceMappingURL=useOnPointerDownOutside.js.map